import { Plus } from 'lucide-react';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

const StageGroupEmptyTableWrapper = styled.div`
  background: #fff;
  padding: 34px 0;
`;

type StageGroupEmptyTableProps = {
  onAddClick: () => void;
};

const StageGroupEmptyBody = ({ onAddClick }: StageGroupEmptyTableProps) => {
  return (
    <StageGroupEmptyTableWrapper className="d-flex flex-column align-items-center">
      <UDText type="headline" className="mb-6">
        Команды еще не добавлены
      </UDText>
      <UDButton variant="dark" className="d-flex align-items-center flex-row" onClick={onAddClick}>
        <Plus size={16} className="mr-2" color={theme.colors.AccentNaplesYellow} />
        {/* <UDColorableIcon
          name="plus"
          componentProps={{ className: 'mr-2 color-AccentNapplesYellow' }}
        /> */}
        Добавить команду
      </UDButton>
    </StageGroupEmptyTableWrapper>
  );
};

export default StageGroupEmptyBody;
